import React from 'react';
import Reflux from 'reflux';
import { Row, Col, Input, Button } from 'bootstrap';
import { Map, List } from 'immutable';
import classnames from 'classnames';

import Dropdown from 'shared/components/menus/dropDown';
import EventShowsMenu from 'shared/components/menus/eventShowMenu';
import { Icon, WithTooltip } from '@shoflo-rundown/polymer.legacy';
import Label from 'shared/components/label/label.jsx';
import ShareMenu, { menuId } from 'main/components/show/cuesheet/shareMenu.jsx';
import Toolbar from 'main/components/show/cuesheet/toolbar.jsx';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

import ActivityAuditListActions from 'flux/actions/ActivityAuditListActions';
import KeyBindingActions from 'flux/actions/KeyBindingActions';
import EventFilterActions from 'flux/actions/EventFilterActions';
import ModalActions from 'shared/flux/actions/ModalActions';
import RouteActions from 'flux/actions/RouteActions';
import SearchActions from 'flux/actions/SearchActions';
import UIRegions from 'shared/constants/UIRegions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import GlobalElementStore from 'flux/stores/GlobalElementStore';
import GlobalElementModalActions from 'flux/actions/GlobalElementModalActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import TeamEventListStore from 'flux/stores/TeamEventListStore';
import TeamViewStore from 'flux/stores/TeamViewStore';
import TeamEventListActions from 'flux/actions/TeamEventListActions';
import AddTagMenu from 'shared/components/tag/addTagMenu';
import AlertBarStore from 'flux/stores/AlertBarStore';

import { ViewRelativePaths } from 'shared/constants/CuesheetViews';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import TeamTabIds from 'shared/constants/TeamTabIdConstants';
import { UPCOMING_EVENT_FILTERS } from 'shared/constants/EventFilters';

export default React.createClass({
  displayName: 'GlobalElementsManagerHeader',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(GlobalElementStore, 'globalElements'),
    Reflux.connect(CuesheetStore, 'cuesheet'),
    Reflux.connect(TeamEventListStore, 'eventList'),
    Reflux.connect(PopoverStore, 'popover'),
    Reflux.connect(AlertBarStore, 'alert'),
  ],

  componentWillMount() {
    const { teamId } = this.context.router.state.params;
    const { eventList } = this.props;

    const populateQuery = Object.assign(
      { page: 1, size: 300 },
      UPCOMING_EVENT_FILTERS.toJS(),
    );

    TeamEventListActions.populate(teamId, populateQuery);

    if (!eventList || eventList.size < 1) {
      EventFilterActions.applyUpcomingFilter();
    }
  },

  getInitialState() {
    return {
      searchInputFocused: false,
    };
  },

  render() {
    const { showId, eventId, teamId } = this.context.router.state.params;
    const { alert, cuesheet, globalElements, user, team, popover } = this.state;
    const show = cuesheet.get('show');

    if (!show) return null;

    const showToolbar = !alert.get('size');

    const searchIconNode = (
      <WithTooltip placement="bottom" tip={TooltipConstants.CSSearch}>
        <div className="cs-info" onClick={this._handleToggleSearchVisibility}>
          <Icon name="search" />
        </div>
      </WithTooltip>
    );

    const quickNavigationNode = (
      <EventShowsMenu
        onShowClick={this._handleShowNavigationClick}
        onEventClick={this._handleEventNavigationClick}
        placement="bottom"
        popoverId="categorizedEventShowsMenu"
        displayNode={<Icon name="table" />}
        events={this._getEventMenuItems()}
        displayTitle
      />
    );

    const shareMenuProps = {
      params: {
        showId,
        eventId,
        teamId,
      },
      displayType: show.get('displayType'),
      user,
      team,
      showMenu: popover.get(menuId),
    };

    return (
      <div id="ge-em-headers-wrapper">
        <div id="ge-em-header">
          <Row className="flexed-rows">
            <Col lg={8} md={8} sm={8} xs={12}>
              <div className="ge-em-hamburger">
                <span
                  className="ge-em-header-back"
                  onClick={this._backButtonClickHandler}
                >
                  <Icon name="arrow-left" />
                  Back to dash
                </span>
                <div className="ge-em-header-title ge-element-selector-dropdown">
                  {this._getElementSetSelector()}
                </div>
              </div>
            </Col>
            <Col lg={8} md={8} sm={8} xs={12}>
              <div className="ge-em-header-toolbar">
                {showToolbar && <Toolbar />}
              </div>
            </Col>
            <Col lg={8} md={8} sm={8} className="hidden-xs">
              <div className="ge-em-header-icons">
                <div className="ge-em-icon-button-wrapper">
                  {this._getGlobalElements()}
                  {quickNavigationNode}
                  {searchIconNode}
                  <ShareMenu {...shareMenuProps} />
                  <WithTooltip
                    placement="bottom"
                    tip={TooltipConstants.CSActivityFeed}
                  >
                    <div
                      className="cs-activity-feed"
                      onClick={ActivityAuditListActions.toggleVisibility}
                    >
                      <Icon name="bolt" />
                    </div>
                  </WithTooltip>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div id="ge-em-subheader">
          <span
            className={classnames('search-wrapper', {
              'has-focus': this.state.searchInputFocused,
            })}
          >
            <Input
              type="text"
              label="Filter by search"
              className="search-input"
              bsSize="small"
              placeholder="Item name"
              ref={this._getInputRef}
              addonBefore={
                <span className="search-prefix-wrapper">
                  <Icon name="search" />
                </span>
              }
              addonAfter={
                cuesheet.get('searchFilter') ? (
                  <Icon name="times" onClick={this._handleClearSearchQuery} />
                ) : null
              }
              onFocus={this._handleSearchInputFocus}
              onBlur={this._handleSearchInputBlur}
              onChange={this._handleQueryChange}
            />
          </span>
          <AddTagMenu
            teamId={globalElements.get('teamId')}
            eventId={globalElements.get('eventId')}
            popoverTitle="Filter by tag(s)"
            displayNode={this._getTagFilterDisplayNode()}
            tags={globalElements.get('tags')}
            activeTagIds={cuesheet.get('labelFilter')}
            wrapperClasses="row-menu-tag tag-filter-wrapper"
            placement="bottom"
            popoverId="global-element-tag-filter"
            isFilter
            displayClear
            clearText="Clear all filters"
            onChange={this._addTagHandler}
          />
          {this._getActiveTagFilterList()}
        </div>
      </div>
    );
  },

  _getInputRef(el) {
    if (!el) return;
    this._searchInput = el;
  },

  _addTagHandler(tagIds) {
    CuesheetRowActions.filterGlobalElementManagerRows('label', tagIds);
  },

  _getTagFilterDisplayNode() {
    return (
      <span>
        <label>Filter by tags</label>
        <Button>
          <Icon name="tag" /> Tags <Icon name="angle-down" />
        </Button>
      </span>
    );
  },

  _getActiveTagFilterList() {
    const { globalElements, cuesheet } = this.state;

    const tags = globalElements.get('tags');
    const labelFilter = cuesheet.get('labelFilter');

    if (!labelFilter || labelFilter.size < 1) return null;

    const tagNodes = labelFilter.map((labelId) => {
      const tag = tags.get(labelId);

      return (
        <Label
          id={tag.get('_id')}
          key={tag.get('_id')}
          text={tag.get('text')}
          color={tag.get('color')}
          classes="active-tag-filters-tag"
          removeIcon="times"
          onRemove={this._handleTagRemoval}
        />
      );
    });

    return (
      <div className="active-tag-filters">
        {tagNodes}
        <a
          className="active-tag-filters-clear"
          onClick={() =>
            CuesheetRowActions.filterGlobalElementManagerRows('label', List())
          }
        >
          Clear all filters
        </a>
      </div>
    );
  },

  _backButtonClickHandler() {
    const { teamId } = this.context.router.state.params;

    ModalActions.hide(UIRegions.InsertGlobalElementsModal);
    RouteActions.goToTeamGlobalElements({
      teamId,
      tabId: TeamTabIds.GlobalElements,
    });
  },

  _handleTagRemoval(tagId) {
    const { cuesheet } = this.state;

    let activeTagIds = cuesheet.get('labelFilter');

    const tagIndex = activeTagIds.indexOf(tagId);
    activeTagIds = activeTagIds.delete(tagIndex);

    CuesheetRowActions.filterGlobalElementManagerRows('label', activeTagIds);
  },

  _handleSearchInputFocus() {
    this.setState({ searchInputFocused: true });
    KeyBindingActions.unbindHotKeys();
  },

  _handleSearchInputBlur() {
    this.setState({ searchInputFocused: false });
    KeyBindingActions.bindHotKeys();
  },

  _handleQueryChange(e) {
    const query = e.target.value;

    if (this.searchQueryTimeout) clearTimeout(this.searchQueryTimeout);

    this.searchQueryTimeout = setTimeout(() => {
      CuesheetRowActions.filterGlobalElementManagerRows('search', query);
    }, 400);
  },

  _handleClearSearchQuery() {
    if (this._searchInput) this._searchInput.refs.input.value = '';
    CuesheetRowActions.filterGlobalElementManagerRows('search', '');
  },

  _getEventMenuItems() {
    const { eventList } = this.state;

    return eventList.get('items')
      ? eventList
          .get('items')
          .toList()
          .map((event) => {
            return event.update('shows', (shows) => {
              return shows.filter((show) => {
                return show.get('archived') ||
                  show.get('deleted') ||
                  show.get('saved') ||
                  show.get('template')
                  ? false
                  : true;
              });
            });
          })
      : List();
  },

  _getGlobalElements() {
    return (
      <div className="cs-toolbar-global-elements">
        <a
          onClick={this._handleDisplayInsertGlobalElementsModal}
          className="fa fa-2x fa-globe"
        />
      </div>
    );
  },

  _handleDisplayInsertGlobalElementsModal() {
    const { teamId } = this.context.router.state.params;
    ModalActions.show(UIRegions.InsertGlobalElementsModal);
    GlobalElementModalActions.populateEventList(teamId, UPCOMING_EVENT_FILTERS);
  },

  _handleToggleSearchVisibility(e) {
    e.preventDefault();
    SearchActions.toggleVisibility();
  },

  _handleShowNavigationClick(event, show) {
    const routeHandler =
      show.get('displayType') === DisplayTypes.list ||
      show.get('displayType') === DisplayTypes.schedule
        ? RouteActions.goToGrid
        : RouteActions.goToShow;

    const { teamId } = this.context.router.state.params;

    routeHandler(
      {
        teamId,
        eventId: event.get('_id'),
        showId: show.get('_id'),
        relativePath: ViewRelativePaths.Compact,
      },
      show.get('displayType'),
    );
  },

  _handleEventNavigationClick(event) {
    const { teamId } = this.context.router.state.params;
    RouteActions.goToEvent({
      teamId,
      eventId: event.get('_id'),
    });
  },

  _getElementSetSelector() {
    const { globalElements, cuesheet } = this.state;

    if (!globalElements.get('elementSets')) return null;

    const title = cuesheet.hasIn(['show', 'title'])
      ? `${cuesheet.getIn(['show', 'title'])}`
      : '';

    const { teamId, eventId, showId } = this.context.router.state.params;

    const elementSetConfig = Map({
      noCaret: false,
      icon: null,
      content: title,
      items: globalElements
        .get('elementSets')
        .filter((elementSet, elementSetId) => elementSetId !== showId)
        .map((elementSet, elementSetId) => {
          return Map({
            type: 'link',
            content: elementSet.get('title'),
            onClick: () =>
              RouteActions.goToGlobalElementManager({
                teamId,
                eventId,
                showId: elementSetId,
              }),
          });
        }),
    });

    return (
      <Dropdown
        classes="generic-dropdown-menu ge-elementset-dropdown"
        config={elementSetConfig}
      />
    );
  },
});
